import styled from 'styled-components';

import { Modal } from 'antd';

export const CustomModal = styled(Modal)`
    width: 920px !important;
`;

export const ContainerModal = styled.div`
    height: 90vh;
    overflow-x: scroll;

    @media screen and (max-width: 920px) {
        height: 190vh;
    }
`

export const ModalDocumentaionContainer = styled.div`
    margin: 1em 0 !important;
    width: 100%;

    p{
        left: 1% !important;
    }
`

export const ContainerTD = styled.th`
    width: 65%;
    max-width: 65%;
    font-weight: 400;
    @media screen and (max-width: 920px) {
      button{
        width: 80%;
        max-width: 80%;
        margin: 0 !important;
        padding: 0 !important;
      }
    }

`

export const DivModalFooter = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    margin-top: 1em;

    @media screen and (max-width: 920px) {
        div{
            width: 90%;
            margin: 0.2em;
        }
    }
`